/* import __COLOCATED_TEMPLATE__ from './price-per-metric.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Args {
  metricPrice: $TSFixMe;
  text: string;
  currentMetricChargeDiscountPercentage?: string;
}

export default class PricePerMetric extends Component<Args> {
  @service declare intl: IntlService;

  formatPrice(price: number): string {
    return this.intl.formatNumber(price, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  private get discountPercentage() {
    return this.args.currentMetricChargeDiscountPercentage
      ? parseFloat(this.args.currentMetricChargeDiscountPercentage)
      : 0;
  }

  get hasDiscount() {
    return this.discountPercentage > 0;
  }

  get pricePerUnitPreDiscount() {
    return this.formatPrice(this.args.metricPrice.per_unit_price / 100);
  }

  get pricePerUnit() {
    if (!this.hasDiscount) {
      return this.pricePerUnitPreDiscount;
    }

    let price: number = this.args.metricPrice.per_unit_price;
    let priceWithDiscount = price * (1 - this.discountPercentage / 100.0);
    return this.formatPrice(priceWithDiscount / 100);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::TooltipsNew::SharedComponents::PricePerMetric': typeof PricePerMetric;
  }
}
